import React from 'react'
import { PageContainer } from 'components/ui'

const Component = () => <PageContainer title="ホーム" />

export default Component
